import React from 'react';
import {
  Avatar,
  Box,
  colors,
  SvgIcon,
  Typography,
} from '@material-ui/core';
import { EVENT_ATTRIBUTES_BY_EVENT_TYPE } from '../../constants/constants';
import { EventDetail } from '../../types';
import IconRenderer from '../IconRenderer';

const EventCell = ({ event }: { event: EventDetail }) => {
  const {
    icon,
    getStatement,
    eventTitle,
  } = EVENT_ATTRIBUTES_BY_EVENT_TYPE[event.eventType];

  return (
    <Box display="flex" alignItems="center">
      <Box mr={1}>
        <Avatar style={{ backgroundColor: colors.blue['500'] }}>
          <SvgIcon fontSize="small">
            <IconRenderer iconName={icon} />
          </SvgIcon>
        </Avatar>
      </Box>
      <Box>
        <Typography variant="h6">
          {eventTitle}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {getStatement(event)}
        </Typography>
      </Box>
    </Box>
  );
};
export default EventCell;
